import Cookies from 'js-cookie'
import request from '@/utils/request'
import BMF from 'browser-md5-file';
const OSS = require('ali-oss');


const state = {
    options:{
        region:"oss-cn-beijing",
        accessKeyId:"",
        accessKeySecret:"",
        stsToken:"",
        bucket:"lng-static"
    },
    expires_in:0,
    folder:"avatar"



};

const mutations = {
    SET_OPTIONS:(state, options)=>{
        state.options = options;
    },
    SET_EXPIRES_IN:(state)=>{
        state.expires_in = (new Date()).getTime() + 3000000;
        let seconds = 2900;
        let expires = new Date(new Date() * 1 + seconds * 1000);
        Cookies.set("oss_token",JSON.stringify(state.options),{expires:expires});
    },
};

const actions = {
    //获取options
    getAccessToken({ commit,state,dispatch} ){
        return new Promise((resolve, reject)=>{
            let now = (new Date()).getTime();
            let oss_token = Cookies.get("oss_token");
            if(now < state.expires_in){
                resolve(state.options);
            }else if(state.expires_in == 0 && oss_token){
                commit("SET_OPTIONS",JSON.parse(oss_token));
                resolve(state.options);
            }else{
                request.get("oss/token").then(res=>{
                    commit("SET_OPTIONS",res.data);
                    commit("SET_EXPIRES_IN");
                    resolve(state.options);
                }).catch(err=>{
                    reject(err);
                });
            }
        });
    },
    uploadFile({commit,state,dispatch},data){
        let {file} = data;
        return new Promise((resolve, reject)=>{
            const bmf = new BMF();
            dispatch("upload/getAccessToken",null,{root:true}).then(options=> {
                bmf.md5(file, (err, md5) => {
                    //生成文件名
                    let filename = md5+file.name.substring(file.name.lastIndexOf("."));
                    //文件夹
                    let folder = "/file";
                    let readerBlob = new FileReader();
                    readerBlob.onload = async (event)=>{
                        let data = new OSS.Buffer(event.target.result);
                        let client = new OSS(options);
                        try {
                            let result = await client.put(folder+filename, data);
                            resolve({name:filename,url:result.url,type:file.name.substring(file.name.lastIndexOf(".")+1)});
                        } catch (e) {
                            return reject(e);
                        }
                    };
                    readerBlob.readAsArrayBuffer(file);
                });
            });
        });
    },

    uploadImg({commit,state,dispatch},data){
        let {file,max,type} = data;
        return new Promise((resolve, reject)=>{
            const bmf = new BMF();
            let errobj = {
                type:"",//size|mime|other
                msg:""
            };
            //判断大小与格式
            max = max?max:1024*1024;
            if(file.size > max){
                errobj.type = "size";
                errobj.msg = "请上传不大于1MB的文件!";
                return reject(errobj);
            }
            if(file.name.indexOf(".") == -1 || !["png","jpeg","jpg","gif"].includes(file.name.substring(file.name.lastIndexOf(".")+1))){
                errobj.type = "mime";
                errobj.msg = "文件格式错误,请上传png,jpeg,jpg,gif格式的图片!";
                return reject(errobj);
            }
            dispatch("upload/getAccessToken",null,{root:true}).then(options=>{
                bmf.md5(file,(err, md5) => {
                    if(err){
                        errobj.type = "other";
                        errobj.msg = "md5生成错误!";
                        return reject(errobj);
                    }
                    //生成文件名
                    let filename = md5+file.name.substring(file.name.lastIndexOf("."));
                    //文件夹
                    let folder = state.folder;
                    //上传
                    let readerBlob = new FileReader();
                    readerBlob.onload = async (event)=>{
                        let data = new OSS.Buffer(event.target.result);
                        let client = new OSS(options);
                        try {
                            let result = await client.put(folder+filename, data);
                            resolve({name:filename,url:result.url});
                        } catch (e) {
                            errobj.type = "other";
                            errobj.msg = e;
                            return reject(errobj);
                        }
                    };
                    readerBlob.readAsArrayBuffer(file);
                });
            }).catch(err=>{
                errobj.type = "other";
                errobj.msg = err;
                reject(errobj);
            });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
